import { AnchorButton } from "src/components/01_atoms/button";
import { Text } from "src/components/01_atoms/text";
import { useClaimStatusSidebar } from "src/hooks/use-claim-status-sidebar";
import { styled, theme } from "src/styles/stitches/theme";
import { ClaimStatusSidebarContentHeader } from "../content-header";
import { ClaimStatusSidebarHeader } from "../header";

const Container = styled("div", {
  display: "none",

  "@bp3": {
    position: "fixed",
    backgroundColor: theme.colors.fillSecondary,
    height: "100%",
    width: "100%",

    maxWidth: "26.25rem",
    right: "-26.25rem",
    zIndex: 2,
    overflowY: "auto",
    transition: "right 0.3s ease-out",
    display: "flex",
    flexDirection: "column",
  },

  variants: {
    isOpen: {
      true: {
        right: 0,
      },
    },
  },
});

const Content = styled("div", {
  padding: `0 ${theme.spacing.spacing32px} ${theme.spacing.spacing32px}`,
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  flex: 1,
});

const ContentWrapper = styled("div", { paddingBottom: theme.spacing.spacing32px });

const Ul = styled("ul", {
  marginLeft: "1rem",
  fontSize: theme.fontSizes.textParagraph2,
  lineHeight: 1.285,
  letterSpacing: theme.letterSpacings.regular,
  fontWeight: theme.fontWeights.medium,
  color: theme.colors.textBaseSubdued,
});

export function RefusedDetailSidebar() {
  const { isRefusedDetailSidebarOpen, setIsRefusedDetailSidebarOpen, refundAmount } =
    useClaimStatusSidebar();

  return (
    <Container isOpen={isRefusedDetailSidebarOpen}>
      <ClaimStatusSidebarHeader
        onCloseButtonClick={() => {
          setIsRefusedDetailSidebarOpen(false);
        }}
      />
      <Content>
        <ContentWrapper>
          <ClaimStatusSidebarContentHeader
            title={
              refundAmount === 0
                ? "Pourquoi ma demande de remboursement peut-elle être refusée ?"
                : "Pourquoi une partie de ma demande de remboursement peut-elle être refusée ?"
            }
            withStatusTag={false}
          />
          <Text variant="paragraph2-Medium" color="textBaseSubdued">
            Le pépin de santé de votre animal n&apos;est pas pris en charge :
          </Text>
          <br />
          <Ul>
            <li>S’il survient pendant les délais de carence</li>
            <li>S’il survient avant votre date de souscription</li>
            <li>Si le problème de santé fait partie de notre liste d’exclusions</li>
            <li>
              Si vous n&apos;avez pas souscrit au forfait bien-être et qu&apos;il s&apos;agit
              d&apos;une dépense de prévention
            </li>
            <li>Si votre plafond de remboursement a été atteint</li>
          </Ul>
        </ContentWrapper>
        <AnchorButton
          type="button"
          variant="accent"
          size="lg"
          href="https://intercom.help/dalma/fr/articles/6154870-les-conditions-de-prise-en-charge-dalma"
          target="_blank"
          rel="noopener noreferrer"
          fluid
        >
          Consulter notre article détaillé
        </AnchorButton>
      </Content>
    </Container>
  );
}
